import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-8 md:py-10 px-4 bg-slate-950" data-id="element-105">
      <div className="max-w-2xl mx-auto" data-id="element-106">
        <FadeIn data-id="element-107">
          <div className="bg-slate-900 border border-slate-800 rounded-2xl p-6 md:p-8 text-center" data-id="element-108">
            <ShieldCheck className="w-10 h-10 text-green-500 mx-auto mb-3" strokeWidth={2} data-id="element-109" />

            <h2 className="text-2xl md:text-3xl font-serif font-bold text-white mb-3 leading-tight" data-id="element-110">
              🛡️ GARANTÍA 7 DÍAS — SIN PREGUNTAS
            </h2>

            <p className="text-base text-slate-300 mb-4" data-id="element-111">
              Si en 7 días no es lo que esperabas:
            </p>

            <ul className="text-left max-w-xs mx-auto space-y-2 mb-4" data-id="element-112">
              <li className="flex items-center gap-2 text-white font-medium" data-id="element-113">
                <span className="text-green-500" data-id="element-114">✅</span> Devolución del 100%
              </li>
              <li className="flex items-center gap-2 text-white font-medium" data-id="element-115">
                <span className="text-green-500" data-id="element-116">✅</span> Sin formularios
              </li>
              <li className="flex items-center gap-2 text-white font-medium" data-id="element-117">
                <span className="text-green-500" data-id="element-118">✅</span> Sin explicar nada
              </li>
            </ul>

            <p className="text-slate-500 text-xs italic" data-id="element-119">
              Tasa de devoluciones: menos del 1%
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}